import React from 'react';
import ReactPaginate from 'react-paginate';

export class Pagination extends React.Component {
  render() {
    return (
      <ReactPaginate
        previousLabel={'<'}
        nextLabel={'>'}
        breakLabel={'...'}
        pageCount={this.props.pageCount}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={this.props.onPageChange}
        breakClassName={'pagination-list'}
        containerClassName={'pagination'}
        activeClassName={'active-pagination'}
        activeLinkClassName={'active-pagination'}
        pageClassName={'pagination-list'}
        previousClassName={'pagination-list'}
        nextClassName={'pagination-list'}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/mapper/pagination.jsx